webpackJsonp([15344225150775],{

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'. fs fs fs fs fs fs fs fs fs fs .\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  '], ['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'. fs fs fs fs fs fs fs fs fs fs .\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  '], ['\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	var _FilterAndSearch = __webpack_require__(35);
	
	var _FilterAndSearch2 = _interopRequireDefault(_FilterAndSearch);
	
	var _CardContainer = __webpack_require__(34);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _StoryCard = __webpack_require__(55);
	
	var _StoryCard2 = _interopRequireDefault(_StoryCard);
	
	var _Pagination = __webpack_require__(54);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'StoriesContainer__Wrapper'
	})(['display:grid;grid-template-columns:repeat(12,1fr);grid-template-rows:auto;grid-column-gap:1rem;grid-template-areas:\'. . fs fs fs fs fs fs fs fs . .\' \'cont cont cont cont cont cont cont cont cont cont cont cont\';margin-top:2.5rem;', ' ', ';'], _globalStyle.media.giant(_templateObject), _globalStyle.media.tablet(_templateObject2));
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'StoriesContainer__Container'
	})(['grid-area:cont;display:flex;flex-direction:column;align-content:center;']);
	
	var StoriesContainer = function (_React$Component) {
	  _inherits(StoriesContainer, _React$Component);
	
	  function StoriesContainer(props) {
	    _classCallCheck(this, StoriesContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      searchQuery: '',
	      blog: _this.props.initialBlog,
	      firstItem: 0,
	      activePage: 0
	    };
	    _this.CARDS = { cols: 2, items: 6 };
	
	    _this.changePage = _this.changePage.bind(_this);
	    _this.handleSort = _this.handleSort.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    return _this;
	  }
	
	  // "in-page" pagination
	
	
	  StoriesContainer.prototype.changePage = function changePage(num) {
	    var _state = this.state,
	        firstItem = _state.firstItem,
	        blog = _state.blog,
	        activePage = _state.activePage,
	        _props = this.props,
	        numStories = _props.numStories,
	        pages = _props.pages;
	
	
	    var maxLength = blog.length - 1;
	
	    var previous = firstItem - numStories;
	    previous = previous < 0 ? 0 : previous;
	
	    var next = firstItem + numStories;
	    next = next > maxLength ? maxLength : next;
	
	    switch (num) {
	      case -1:
	        //get previous page
	        this.setState({
	          firstItem: previous,
	          activePage: activePage - 1 < 0 ? 0 : activePage - 1
	        });
	        return;
	      case 0:
	        //get next page
	        this.setState({
	          firstItem: next,
	          activePage: activePage + 2 > pages ? pages - 1 : activePage + 1
	        });
	        return;
	      default:
	        //get page #num
	        this.setState({
	          firstItem: numStories * (num - 1),
	          activePage: num - 1
	        });
	        return;
	    }
	  };
	
	  // handles sort by 'all', 'by author', 'by title', 'by length'
	
	
	  StoriesContainer.prototype.handleSort = function handleSort(str) {
	    var blog = [].concat(this.state.blog),
	        loadedBlog = [].concat(this.props.initialBlog);
	
	    switch (str) {
	      case 'all':
	        //show all cards
	        this.setState({ blog: loadedBlog });
	        return;
	      case 'by author':
	        // sort by author
	        this.setState({ blog: this.sortBy('author', blog) });
	        return;
	      case 'by title':
	        //sort by title
	        this.setState({ blog: this.sortBy('title', blog) });
	        return;
	      case 'by length':
	        // sort by timeToRead
	        this.setState({ blog: this.sortBy('timeToRead', blog) });
	        return;
	      default:
	        return;
	    }
	  };
	
	  //!!! must be changed for usage of Contentful
	
	
	  StoriesContainer.prototype.handleSearch = function handleSearch() {
	    //search in 'this.props.initialBlog'
	    var loadedBlog = [].concat(this.props.initialBlog),
	        searchQuery = this.state.searchQuery;
	
	
	    if (searchQuery) {
	      //
	    }
	  };
	
	  StoriesContainer.prototype.handleInput = function handleInput(val) {
	    this.setState({
	      searchQuery: val
	    });
	  };
	
	  // slice the array of stories according the limit(numStories) per page
	
	
	  StoriesContainer.prototype.setPagination = function setPagination() {
	    var numStories = this.props.numStories,
	        _state2 = this.state,
	        firstItem = _state2.firstItem,
	        blog = _state2.blog;
	
	    return blog.slice(firstItem, firstItem + numStories);
	  };
	
	  StoriesContainer.prototype.sortBy = function sortBy(sortField, arr) {
	    var sorted = arr.sort(function (a, b) {
	      var elemA = void 0,
	          elemB = void 0;
	      if (sortField === 'author') {
	        elemA = a.node[sortField].lastName;
	        elemB = b.node[sortField].lastName;
	      } else if (sortField === 'title') {
	        elemA = a.node[sortField];
	        elemB = b.node[sortField];
	      } else {
	        elemA = a.node.content.childMarkdownRemark[sortField];
	        elemB = b.node.content.childMarkdownRemark[sortField];
	      }
	
	      if (elemA < elemB) {
	        return -1;
	      }
	      if (elemA > elemB) {
	        return 1;
	      }
	      return 0;
	    });
	    return sorted;
	  };
	
	  StoriesContainer.prototype.render = function render() {
	    var arr = this.setPagination();
	    //console.log(arr)
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(_FilterAndSearch2.default, {
	        area: 'fs',
	        items: this.props.menuFilter,
	        changeDates: this.handleSort,
	        search: this.handleSearch,
	        input: this.handleInput
	      }),
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _CardContainer2.default,
	          { cols: this.CARDS.cols, story: true },
	          arr.map(function (elem) {
	            return _react2.default.createElement(_StoryCard2.default, {
	              key: elem.node.id,
	              title: elem.node.title,
	              slug: elem.node.slug,
	              author: elem.node.author.fullName,
	              date: elem.node.publishDate,
	              text: elem.node.content.childMarkdownRemark.excerpt,
	              tags: elem.node.tags,
	              img: elem.node.featureImage.resolutions.src,
	              time: elem.node.content.childMarkdownRemark.timeToRead
	            });
	          })
	        ),
	        _react2.default.createElement(_Pagination2.default, {
	          onChange: this.changePage,
	          background: this.props.theme.white,
	          pageNum: this.props.pages,
	          active: this.state.activePage
	        })
	      )
	    );
	  };
	
	  return StoriesContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _styledComponents.withTheme)(StoriesContainer);
	
	
	StoriesContainer.propTypes = {
	  initialBlog: _propTypes2.default.array,
	  menuFilter: _propTypes2.default.array.isRequired,
	  pages: _propTypes2.default.number.isRequired,
	  numStories: _propTypes2.default.number.isRequired,
	  theme: _propTypes2.default.PropTypes.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
	};

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _StoriesContainer = __webpack_require__(98);
	
	var _StoriesContainer2 = _interopRequireDefault(_StoriesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// "in page" pagination of stories
	// can be changed when the number of stories would grow significantly
	// example: https://www.gatsbycentral.com/pagination-in-gatsby
	var storiesPerPage = 4;
	
	var StoriesPage = function StoriesPage(_ref) {
	  var data = _ref.data;
	  var site = data.site,
	      blog = data.allContentfulBlog,
	      pages = Math.ceil(blog.edges.length / storiesPerPage);
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hero2.default, { type: 'stories' }),
	    _react2.default.createElement(_StoriesContainer2.default, {
	      menuFilter: site.siteMetadata.filterOptions.stories,
	      initialBlog: blog.edges,
	      pages: pages,
	      numStories: storiesPerPage
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	StoriesPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = StoriesPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-stories-js-b309c082ac512f82c9a1.js